

export const ValidateCommentType = (commentType) => {
        if(commentType == '') {
            return true
        }
    }

    export const ValidatePost = (post) => {
        if(post == '') {
            return true
        }
    }
